import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { useAsync } from '@src/redux/hooks/useAsync';
import { saveUserInfo, getFetchUser } from './actions';
import { SAVE_USER_INFO, GET_FETCHUSER } from './constants';

const userInfoSelector = (state) => {
  return state.user;
};

export const useUser = {
  state: () => {
    return useSelect(userInfoSelector);
  },
  actions: () => {
    return {
      saveUserInfo: useAction(saveUserInfo, {
        saga: useAsync(SAVE_USER_INFO),
      }),
      getFetchUser: useAction(getFetchUser, {
        saga: useAsync(GET_FETCHUSER),
      }),
    };
  },
};
